import { render, staticRenderFns } from "./organization-details-header.vue?vue&type=template&id=82d83db8"
import script from "./organization-details-header.vue?vue&type=script&lang=js"
export * from "./organization-details-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports